module.exports = __webpack_public_path__ + "assets/images/pages/job/image-detail-5.png?ef1657e5";